import { EMPTY_VALUE } from 'commerce-subscription-lib/public/constants';
import { handleError } from 'commerce-subscription-lib/public/utilities';
import { SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import useNewPropertiesForm from 'customer-data-properties/form/useNewPropertiesForm';
// @ts-expect-error Could not find a declaration file for module
import UnsavedChanges from 'customer-data-properties/savebar/UnsavedChanges';
import { useCallback, useState } from 'react';
import { useUpdateSubscriptionProperties } from '../hooks/useUpdateSubscriptionProperties';
import { jsx as _jsx } from "react/jsx-runtime";
function getGqlUpdatesFromDraftUpdates(draftUpdates) {
  return Object.entries(draftUpdates).map(([name, value]) => ({
    name,
    value
  }));
}
export function MaybeEditableSubscriptionStatus({
  objectId,
  editableAreas,
  subscriptionStatus
}) {
  const [draft, setDraft] = useState({});
  function getSavedValue(propertyName) {
    switch (propertyName) {
      case 'hs_status':
        return subscriptionStatus ? subscriptionStatus.value : null;
      default:
        return undefined;
    }
  }
  // Creates the inputs for the card that connects to the sidebar save bar
  const {
    status,
    inputs,
    reset
  } = useNewPropertiesForm({
    getSavedValue,
    objectId,
    objectTypeId: SUBSCRIPTION_TYPE_ID,
    onChange: useCallback(changes => {
      setDraft(changes);
    }, []),
    properties: [{
      propertyName: 'hs_status'
    }],
    values: draft
  });
  const handleClearDraft = useCallback(() => {
    setDraft({});
    reset();
  }, [reset]);
  const [onSubmit] = useUpdateSubscriptionProperties(objectId, getGqlUpdatesFromDraftUpdates(draft), handleClearDraft);
  const handleSaveDraft = useCallback(event => {
    event.preventDefault();
    if (!status.saveable) {
      return;
    }
    onSubmit().catch(handleError);
  }, [status, onSubmit]);
  return /*#__PURE__*/_jsx(UnsavedChanges, {
    editableAreas: editableAreas,
    changes: Object.keys(draft).length,
    onCancel: handleClearDraft,
    onSave: handleSaveDraft,
    children: inputs.map(({
      render,
      property
    }) => /*#__PURE__*/_jsx("span", {
      children: render({
        use: 'floating',
        formControlProps: {
          label: null,
          verticalSeparation: 'flush'
        },
        inputProps: {
          placeholder: EMPTY_VALUE
        }
      })
    }, property.name))
  });
}